import React from 'react'

function DailyAnalysis() {
  return (
    <div>
  
    <section className="daily-analusis-stocks-section da-page py-70 px-60">
      <div className="container-fluid">
        <div className="daily-analusis-stocks-container">
          <a href="/daily-analysis-chart">
            <div className="stocks-details-left">
              <h4>ALLCARGO TERMINAL</h4>
              <p className="stocks-level">Level: 70</p>
              <p className="stock-pattern">Pattern: CHANNEL</p>
            </div>
            <div className="stocks-details-right">
              <h4>19/02</h4>
              <div className="stock-graph">
                <img src="img/stock-graph.svg" alt="stock-graph" loading="lazy" />
              </div>
            </div>
          </a>
          <a href="/daily-analysis-chart">
            <div className="stocks-details-left">
              <h4>ALLCARGO TERMINAL</h4>
              <p className="stocks-level">Level: 70</p>
              <p className="stock-pattern">Pattern: CHANNEL</p>
            </div>
            <div className="stocks-details-right">
              <h4>19/02</h4>
              <div className="stock-graph">
                <img src="img/stock-graph.svg" alt="stock-graph" loading="lazy" />
              </div>
            </div>
          </a>
          <a href="/daily-analysis-chart">
            <div className="stocks-details-left">
              <h4>ALLCARGO TERMINAL</h4>
              <p className="stocks-level">Level: 70</p>
              <p className="stock-pattern">Pattern: CHANNEL</p>
            </div>
            <div className="stocks-details-right">
              <h4>19/02</h4>
              <div className="stock-graph">
                <img src="img/stock-graph.svg" alt="stock-graph" loading="lazy" />
              </div>
            </div>
          </a>
          <a href="/daily-analysis-chart">
            <div className="stocks-details-left">
              <h4>ALLCARGO TERMINAL</h4>
              <p className="stocks-level">Level: 70</p>
              <p className="stock-pattern">Pattern: CHANNEL</p>
            </div>
            <div className="stocks-details-right">
              <h4>19/02</h4>
              <div className="stock-graph">
                <img src="img/stock-graph.svg" alt="stock-graph" loading="lazy" />
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>   
  </div>
  )
}

export default DailyAnalysis